import React, { useState } from "react";
import Card from "components/card";

interface WidgetProps {
  icon: JSX.Element;
  title: string;
  subtitle: string;
  extra?: React.ReactNode;
  options?: string[];
  onChange?: (value: string) => void;
}

const Widget = ({ icon, title, subtitle, extra, options, onChange }: WidgetProps) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (value: string) => {
    setOpen(false);
    onChange?.(value);
  };

  return (
    <Card extra="!flex-row flex-grow items-center rounded-[20px] relative">
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className="rounded-full bg-lightPrimary p-3">
          <span className="flex items-center text-brand-500">{icon}</span>
        </div>
      </div>

      <div className="h-50 ml-4 flex w-auto flex-col justify-center relative">
        <p className="font-dm text-sm font-medium text-gray-600">{title}</p>

        {options && onChange ? (
          <div className="relative">
            <button
              onClick={() => setOpen(!open)}
              className="text-left text-xl font-bold text-navy-700 focus:outline-none"
            >
              {subtitle}
            </button>

            {open && (
              <ul className="absolute z-10 mt-1 w-40 bg-white rounded shadow-lg border">
                {options.map((opt) => (
                  <li
                    key={opt}
                    onClick={() => handleSelect(opt)}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                  >
                    {opt}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <h4 className="text-xl font-bold text-navy-700">{subtitle}</h4>
        )}
      </div>

      {extra && <div className="absolute top-2 right-3">{extra}</div>}
    </Card>
  );
};

export default Widget;
